'use client';

/**  웹에서 상품 찜 후에 컬렉션을 선택할 수 있는 바텀시트를 보여줌 */

type Params = { pid: string; image: string };

export const showCollection = ({ pid, image }: Params) => {
  if (!window) return;

  const message = {
    cmd: 'showFavFolderSelectPopup',
    parameters: {
      pid,
    },
  };

  // ios
  globalThis.window.webkit?.messageHandlers?.Common?.postMessage?.(message);

  // aos
  globalThis.window.Common?.showFavFolderSelectPopup?.(pid, image);
};
